module.exports = {"id":"dp1_2l3q7","text":"Evaluating Information","instructions":"What is a common goal of clickbait strategies?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":true,"options":[{"id":"dp1_2l3q7-a1","text":"Maximise engagement","score":3.7},{"id":"dp1_2l3q7-a2","text":"Improve accuracy","score":1.3},{"id":"dp1_2l3q7-a3","text":"Reduce bias","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q7.json
// module id = 955
// module chunks = 41